const GET_ASSET_ITEM_STATUS_PURCHASE_ORDER = 'GET_ASSET_ITEM_STATUS_PURCHASE_ORDER'
const SET_ASSET_ITEM_STATUS_PURCHASE_ORDER = 'SET_ASSET_ITEM_STATUS_PURCHASE_ORDER'

 const SET_IS_ASSET_ITEM_STATUS_PURCHASE_ORDER_CALLED = "SET_IS_ASSET_ITEM_STATUS_PURCHASE_ORDER_CALLED"
export {
    GET_ASSET_ITEM_STATUS_PURCHASE_ORDER,
    SET_ASSET_ITEM_STATUS_PURCHASE_ORDER,
    SET_IS_ASSET_ITEM_STATUS_PURCHASE_ORDER_CALLED
}
